<section class="content-header" style="padding: 0.5% !important">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-md-6">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item">
              <a [routerLink]="['/']"
                ><i class="fas fa-home"></i> &nbsp;Trang chủ</a
              >
            </li>
            <li class="breadcrumb-item active">Thống kê nhập học</li>
          </ol>
        </div>
      </div>
    </div>
  </section>
  
  <section class="content cus-body">
      <div class="card">
          <div class="card-body">
              <form class="form-horizontal" [formGroup]="filter">
                  <div class="row g-3">
                      <div class="col">
                          <label style="color: white;">Năm nhập học</label>
                          <select class="form-control" (change)="submit()" formControlName="Nam_hoc">
                              <option value="0">Tất cả</option>
                              <option *ngFor="let i of lstNamHoc" value="{{i}}">{{i}}</option>
                          </select>
                      </div>
                      <div class="col ">
                          <label style="color: white;">Ngành nhập học</label>
                          <select class="form-control" (change)="submit()" formControlName="ID_nganh">
                              <option value="0">Tất cả</option>
                              <option *ngFor="let i of lstChuyenNganh" value="{{i.ID_nganh}}">{{i.Ten_nganh}}</option>
                          </select>
                      </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                        <button
                          class="btn btn-info btn-sm"
                          (click)="submit()"
                          style="float: left; margin-right: 5px; margin-top: 10px;"
                        >
                          <i class="fas fa-search"></i> Thống kê dữ liệu
                        </button>
                      </div>
                  </div>
              </form>
          </div>
      </div>
  </section>
  
  <section class="content cus-body" 

  >
    <div class="card">
      <div class="card-body">
        <div
          class="table-responsive"
          style="width: 100%; height: auto; max-height: 100%"
        >
          <table class="table table-bordered table-fixed" style="width: 100%; font-size: 12px; margin: auto;
          padding: 10px;">
            <thead style="background-color: #337ab7;color: white;">
              <tr class="w-100">
                <th>STT</th>
                <th>Ngành</th>
                <th>Chỉ tiêu</th>
                <th>SL trúng tuyển</th>
                <th>Xác nhận nhập học</th>
                <th>Tỷ lệ XNNH/CT</th>
                <th>Tỷ lệ XNNH/TT</th>
                <th>SL đăng ký</th>
                <th>SL đã thu phiếu điểm</th>
                <th>SL đã trả giấy báo</th>
                <th>SL đã thu hồ sơ</th>
                <th>SL đã thu học phí</th>
                <th>SL hoàn thành</th>
                <th>Sl đã rút hồ sơ</th>
                <th>Tổng tiền</th>
              </tr>
            </thead>
            <tbody>
              <tr style="background-color: beige;">
                <td colspan="2">Tổng</td>
                <td class="center">{{ ChiTieu }}</td>
                <td class="center">{{ TrungTuyen }}</td>
                <td class="center">{{ Nhap_hoc }}</td>
                <td class="center">{{XNNH_CT | number}}%</td>
                <td class="center">{{XNNH_TT | number}}%</td>
                <td class="center">{{ Dang_ky | number }}</td>
                <td class="center">{{ Da_thu_phieu_diem | number }}</td>
                <td class="center">{{ Tra_giay_bao | number }}</td>
                <td class="center">{{ Da_thu_ho_so | number }}</td>
                <td class="center">{{ Da_thu_hoc_phi | number }}</td>
                <td class="center">{{ Hoan_thanh | number }}</td>
                <td class="center">{{ Da_rut_ho_so | number }}</td>
                <td class="center">{{ Tong_tien | number }}</td>
              </tr>
              <tr *ngFor="let i of dataTable; let stt = index">
                <td>{{ stt + 1 }}</td>
                <td>{{ i.Ten_nganh }}</td>
                <td class="center">{{ i.Chi_tieu_tuyen_sinh | number }}</td>
                <td class="center">{{ i.Trung_tuyen | number }}</td>
                <td class="center">{{ i.Xac_nhan_nhap_hoc | number }}</td>
                <td class="center">{{ (i.Xac_nhan_nhap_hoc / i.Chi_tieu_tuyen_sinh) *100 | number }}%</td>
                <td class="center">{{ (i.Xac_nhan_nhap_hoc / i.Trung_tuyen)*100 | number }}%</td>
                <td class="center">{{ i.Dang_ky | number }}</td>
                <td class="center">{{ i.Da_thu_phieu_diem | number }}</td>
                <td class="center">{{ i.Da_tra_giay_bao | number }}</td>
                <td class="center">{{ i.Da_thu_ho_so | number }}</td>
                <td class="center">{{ i.Da_thu_hoc_phi | number }}</td>
                <td class="center">{{ i.Da_hoan_thanh | number }}</td>
                <td class="center">{{ i.Da_rut_ho_so | number }}</td>
                <td class="center">{{ i.TongTien | number }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
  
